<div class="offer-details-container">
    <nova-detail-toolbar *ngIf="offerData" [title]="title" [template]="buttonsTemplate"
                         (onGoBack)="goBack()"></nova-detail-toolbar>
    <ng-template #buttonsTemplate>
        <ng-container>
            <div class="buttons-placement flex-row justify-end items-center">
                <div *ngIf="!editMode">
                    <ng-container>
                        <button *ngIf="((offerStatus.Rescinded | arrayContains: offerData?.eligibleStatuses))" type="button" class="mat-raised-button mat-secondary" color="secondary"
                                (click)=" openRescindReasonDialog()" [disabled]="isOperationProcessing" data-qa-id="shared_rescind_offer_btn">
                            Rescind offer
                        </button>
                        <button *ngIf="offerData?.canReactivateOffer" type="button" class="mat-raised-button mat-secondary" color="secondary"
                                (click)="enableEditMode()" data-qa-id="shared_reactivate_offer_btn">
                            Re-activate offer
                        </button>
                        <button
                            *ngIf="(offerStatus.VendorReview | arrayContains: offerData?.eligibleStatuses ) && !offerData?.canReactivateOffer"
                            [disabled]="disableShowButtons" type="button" class="mat-raised-button mat-secondary" color="secondary"
                            (click)="updateStatusShowVendor()" data-qa-id="shared_show_vendor_btn">
                            Show to Vendor
                        </button>
                        <button *ngIf="(offerStatus.RecruiterReview | arrayContains: offerData?.eligibleStatuses )" type="button" class="mat-raised-button mat-secondary" color="secondary"
                        [disabled]="disableShowButtons" (click)="updateStatusShowRecruiter()" data-qa-id="shared_show_recruiter_btn">
                            Show to Recruiter
                        </button>
                        <button *ngIf="(offerStatus.ContractRequested | arrayContains: offerData?.eligibleStatuses )" type="button" class="mat-raised-button mat-secondary" color="secondary"
                                (click)="openContractRequestDialog(true)" data-qa-id="shared_contract_request_offer_btn">
                            Contract Request Offer
                        </button>
                    </ng-container>
                </div>
                <div>
                    <ng-container>
                        <button *ngIf="editMode && (offerStatus.VendorReview | arrayContains: offerData?.eligibleStatuses )" type="button" [disabled]="detailsFormGroup.invalid" class="save-vendor mat-raised-button mat-secondary" color="secondary"
                                (click)="updateOffer(true)" data-qa-id="shared_save_show_vendor_btn">
                            Save + Show to vendor
                        </button>
                    </ng-container>
                    <button *ngIf="!editMode && offerData?.canEdit && !offerData?.canReactivateOffer" type="button" class="mat-raised-button mat-primary" color="primary"
                            (click)="enableEditMode()" data-qa-id="shared_edit_offer_btn">
                        Edit
                    </button>
                    <button *ngIf="showCreateContractRequestButton()" type="button" class="mat-raised-button mat-primary" color="primary"
                    (click)="openMargin(offerData?.marginId)" data-qa-id="shared_create_contract_req_offer_btn">
                        CREATE CONTRACT REQUEST
                    </button>
                    <ng-container>
                        <button mat-button
                                class="mat-raised-button mat-secondary"
                                color="secondary"
                                *ngIf="offerData?.readyForVerballyAccepted"
                                aria-label="Button to share offer as verbally accepted"
                                data-qa-id="verbally_accept_button"
                                [matTooltip]="offerData?.offerVerballyAccepted ? 'This offer has been shared as verbally accepted' : 'Share that this offer has been verbally accepted'"
                                [disabled]="offerData?.offerVerballyAccepted"
                                (click)="verballyAcceptOffer()">
                            {{offerData.offerVerballyAccepted ? 'VERBALLY ACCEPTED' : 'VERBALLY ACCEPT'}}
                        </button>
                    </ng-container>
                    <button *ngIf="!editMode && (offerStatus.Declined | arrayContains: offerData?.eligibleStatuses )" type="button" class="mat-raised-button mat-secondary" color="secondary"
                            (click)="declineOffer()" data-qa-id="shared_decline_offer_btn">
                        Decline Offer
                    </button>
                    <button *ngIf="editMode && offerData?.canEdit" type="submit" [disabled]="detailsFormGroup.invalid" class="mat-raised-button mat-primary" color="primary"
                            (click)="updateOffer()" data-qa-id="shared_save_btn">
                        Save
                    </button>
                    <button *ngIf="editMode && detailsFormGroup.controls.isContractRequestStatus.value && offerData?.offerType === offerTypeEnum.Agency" type="button" [disabled]="detailsFormGroup.invalid" class="mat-raised-button mat-primary" color="primary"
                            (click)="openContractRequestDialog(false)" data-qa-id="SaveReqContractBtn">
                        Save + Request Contract
                    </button>
                    <button *ngIf="editMode && offerData?.canEdit" type="button" class="mat-raised-button mat-secondary" color="secondary" (click)="enableViewMode()" data-qa-id="CancelEditBtn">Cancel</button>
                </div>
            </div>
        </ng-container>
    </ng-template>
    <ng-container>
        <nova-banner *ngIf="editMode && validateCandidateProfessionJobs" bannerType="alert"
            bannerMessage="Clinician's profession must match the job's profession. Please review and update before creating an Offer.">
        </nova-banner>
    </ng-container>
    <div class="progress flex-grow flex-row justify-center" *ngIf="isLoading">
        <mat-progress-spinner mode="indeterminate" diameter="96"></mat-progress-spinner>
    </div>
    <div class="offer-details-content flex-row-wrap justify-start gap-16">
        <mat-card class="info">
            <form [formGroup]="detailsFormGroup">
                <table class="offer-info-table" aria-label="table">
                    <tbody>
                        <tr class="hidden">
                            <th scope="col"></th>
                            <th scope="col"></th>
                            <th scope="col"></th>
                        </tr>
                        <ng-container *ngIf="offerData?.offerType !== offerTypeEnum.Direct">
                            <tr>
                                <td><span class="label-text">Vendor</span></td>
                                <td>
                                    <span>{{ offerData?.vendorName }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">Vendor Contact</span></td>
                                <td>
                                    <mat-form-field *ngIf="editMode" class="mc-form-field mc-form-field__shift-type--width">
                                        <mat-select formControlName="vendorContactId">
                                            <mat-option *ngFor="let option of vendorLookups?.contacts" [value]="option.id">{{ option.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <span *ngIf="!editMode"><a class="nova__link" href="mailto:{{ offerData?.vendorContactEmail }}">{{ offerData?.vendorContactName }}</a></span>
                                </td>
                            </tr>
                        </ng-container>

                        <tr>
                            <td><span class="label-text">Candidate</span></td>
                            <td>
                                <span>
                                    <a *ngIf="!editMode && urlParent && offerData?.candidateId" class="nova__link" target="_blank"
                                        [routerLink]="['/recruiting/candidates', offerData?.candidateId, 'new-profile']" rel="noopener">{{ offerData?.candidateName }}</a>
                                    <span *ngIf="editMode">{{ offerData?.candidateName }}</span>
                                    <span *ngIf="!offerData?.candidateId">{{ offerData?.candidateName }}</span>
                                    ({{offerData?.candidateEmail}})
                                </span>
                            </td>
                        </tr>

                        <tr>
                            <td><span class="label-text">Offer Status</span></td>
                            <td>
                                <span *ngIf="!editMode">{{ offerData?.status}}</span>
                                <span *ngIf="editMode">{{ detailsFormGroup?.controls.status.value}}</span>
                            </td>
                        </tr>

                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">Contract Type</span></td>
                            <td>
                                <span *ngIf="!editMode">{{ offerData?.contractType }}</span>
                                <mat-form-field *ngIf="editMode" class="mc-form-field mc-form-field__shift-type--width">
                                    <mat-select formControlName="contractTypeId">
                                        <mat-option *ngFor="let option of lookups?.contracts" [value]="option.id">{{ option.code }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                        </tr>

                        <tr>
                            <td><span class="label-text">Contract Status</span></td>
                            <td>
                                <span (click)="goToContractRequest(offerData?.contractRequestId, offerData?.marginId)" class="nova__link">{{ offerData?.contractRequestStatus }}</span>
                            </td>
                        </tr>

                        <tr>
                            <td><span class="label-text">Position Type</span></td>
                            <td>
                                <span>{{ offerData?.positionType }}</span>
                            </td>
                        </tr>
                        <tr *ngIf="offerData?.offerType === offerTypeEnum.Direct">
                            <td><span class="label-text">Unit</span></td>
                            <td>
                                <ng-container *ngIf="offerData?.unitDescriptionFormId; else unitNameText">
                                    <a (click)="openUnitFormUrl($event, offerData?.unitDescriptionFormId)" class="nova__link" target="_blank" rel="noopener">{{ offerData?.unitName }}</a>
                                </ng-container>
                                <ng-template #unitNameText>
                                    <span>{{ offerData?.unitName }}</span>
                                </ng-template>
                            </td>
                        </tr>
                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td>
                                <span class="label-text">{{!editMode || offerData?.offerType === offerTypeEnum.Direct ? 'Facility' : 'Facility *'}}</span>
                            </td>
                            <td>
                                <ng-container>
                                    <a *ngIf="!editMode" (click)="openFacility(offerData?.facilityId)" class="nova__link">{{ offerData?.facilityName }}</a>
                                    <span *ngIf="!urlParent && editMode">{{ offerData?.facilityName }}</span>
                                </ng-container>

                                <ng-container *ngIf="offerData?.offerType === offerTypeEnum.Direct; else facilityNonDirect">
                                    <a *ngIf="urlParent && editMode" class="nova__link" target="_blank" [routerLink]="['/' + urlParent + '/facilities', offerData?.facilityId]" rel="noopener">{{ offerData?.facilityName }}</a>
                                </ng-container>
                                <ng-template #facilityNonDirect>

                                    <mat-form-field *ngIf="editMode" class="extended-field full-width">
                                        <input type="text"
                                               matInput
                                               formControlName="facilityValues"
                                               [matAutocomplete]="facilityAuto">
                                        <mat-autocomplete #facilityAuto="matAutocomplete"
                                                          (optionSelected)="facilitySelection($event)"
                                                          [displayWith]="displayFieldName"
                                                          autoActiveFirstOption #auto="matAutocomplete">
                                            <mat-option *ngFor="let option of filteredFacilityIdOptions | async" [value]="option">
                                                {{ option.name }} - {{ option.id }}
                                            </mat-option>
                                            <mat-option *ngIf="!filteredFacilityIdOptions">No facilities available to choose from.</mat-option>
                                        </mat-autocomplete>
                                        <mat-error>Please enter a Facility.</mat-error>
                                    </mat-form-field>

                                </ng-template>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Facility Address</span></td>
                            <td>
                                <div *ngIf="offerData?.facilityAddress">
                                    {{ offerData.facilityAddress }}
                                </div>
                                <div *ngIf="offerData?.facilityCity && offerData?.facilityState && offerData?.facilityZip">
                                    {{ offerData.facilityCity }}, {{ offerData.facilityState }} {{ offerData.facilityZip }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">AM</span></td>
                            <td>
                                <span *ngIf="!editMode">{{ offerData?.accountManagerName }}</span>
                                <span *ngIf="editMode">{{ facilityLookup?.accountManager }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="label-text">Job ID</span></td>
                            <td>
                                <span *ngIf="!editMode" (click)="goToJobId(offerData.jobId)" class="nova__link">{{ offerData?.jobId }}</span>
                                <mat-form-field *ngIf="editMode">
                                    <input type="number" matInput formControlName="jobId" [matAutocomplete]="jobIdAuto" (change)="jobIdSelection($event)">
                                    <mat-autocomplete #jobIdAuto="matAutocomplete" [displayWith]="displayJobIds" (optionSelected)="jobIdSelection($event)">
                                        <mat-option *ngFor="let job of filteredJobIdOptions | async" [value]="job">{{ job }} </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </td>
                        </tr>
                        <ng-container *ngIf="showSampleMarginButton()">
                            <tr class="margin-btn-container">
                                <td><span class="label-text">Offer Margin</span></td>
                                <td>
                                    <ng-container>
                                        <button data-qa-id="addSampleMargin" class="margin-btn mat-raised-button mat-primary" color="primary"
                                            (click)="duplicateSampleMargin()" [disabled]="disableSampleMargin()" [matTooltip]="sampleMarginTooltip()">
                                            ADD SAMPLE MARGIN
                                        </button>
                                    </ng-container>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="showCreateAndImportMarginButtons()">
                            <tr class="margin-btn-container">
                                <td><span class="label-text">Offer Margin</span></td>
                                <td>
                                    <ng-container>
                                        <button class="margin-btn mat-raised-button mat-primary" color="primary" (click)="showImportMarginDialog()">
                                            IMPORT MARGIN
                                        </button>
                                    </ng-container>
                                    <ng-container>
                                        <button class="mat-raised-button mat-secondary" color="secondary" (click)="createOfferMargin()">
                                            CREATE MARGIN
                                        </button>
                                    </ng-container>
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="offerData?.marginId">
                            <td><span class="label-text">Offer Margin</span></td>
                            <td>
                                <span>
                                    <a (click)="openMarginCalculator(offerData?.marginId)" class="nova__link ng-star-inserted">{{ offerData?.marginId }}</a>
                                    <ng-container *ngIf="offerData?.importedFromMarginId">
                                        (Margin created from {{ offerData?.importedFromMarginId }} margin {{ offerData?.marginImportDateUtc | date: 'MM/dd/yyyy - hh:mm a' }})
                                    </ng-container>
                                </span>
                            </td>
                        </tr>

                        <ng-container *ngIf="showImportMarginButton()">
                            <ng-container>
                                <tr>
                                    <td></td>
                                    <td>
                                        <button class="margin-btn mat-raised-button mat-primary" color="primary"  (click)="showImportMarginDialog()" >
                                            IMPORT MARGIN
                                        </button>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>

                        <tr class="pt-0" *ngIf="offerMarginDifferences && offerMarginDifferences.length">
                            <td><span class="label-text"></span></td>
                            <td>
                                <span (click)="openMarginDifferences()" class="nova__link ng-star-inserted">View Differences</span>
                            </td>
                        </tr>

                        <tr><td colspan="2"></td></tr>

                        <tr>
                            <td>
                                <span class="label-text">Candidate Profession</span>
                            </td>
                            <td>
                                <span>{{ offerData?.professionName }}</span>
                            </td>
                        </tr>

                        <ng-container>
                            <tr>
                                <td>
                                    <span class="label-text">Job Profession</span>
                                </td>
                                <td>
                                    <span>{{ jobProfessionName || offerData?.jobProfessionName }}</span>
                                </td>
                            </tr>
                            <tr *ngIf="validateCandidateProfessionJobs">
                                <td colspan="2">
                                    <mat-error>Clinician's profession must match the job's profession. Please review and update before creating
                                        an Offer.</mat-error>
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="featureFlag.JobEditWorkModelAndWorkType && !editMode && offerData?.isRemoteBooking !== null" data-qa-id="job-details-work-model">
                            <td><span class="label-text">Work Model</span></td>
                            <td>
                               <span data-qa-id="ProfessionView">{{ !offerData?.isRemoteBooking ? 'On-site' : 'Remote' }}</span>
                            </td>
                        </tr>
                        <tr *ngIf="featureFlag.JobEditWorkModelAndWorkType && editMode && offerData?.isRemoteBooking !== null" data-qa-id="job-details-work-model">
                            <td>
                                <span class="label-text">Work Model</span>
                            </td>
                            <td>
                                <mat-radio-group formControlName="isRemoteBooking" name="isRemoteBooking" data-qa-id="job-details-work-model-radio">
                                    <mat-radio-button class="mx-2" [value]="false">On-site</mat-radio-button>
                                    <mat-radio-button class="mx-2" [value]="true">Remote</mat-radio-button>
                                </mat-radio-group>
                            </td>
                        </tr>
                        <tr *ngIf="featureFlag.JobEditWorkModelAndWorkType && offerData?.isPatientFacing !== null" data-qa-id="job-details-work-type">
                            <td><span class="label-text">Work Type</span></td>
                            <td> 
                               <span>{{ (offerData?.isPatientFacing ?? true) ? 'Patient-facing' : 'Non Patient-facing' }}</span>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <span class="label-text">Job Specialty</span>
                            </td>
                            <td>
                                <span *ngIf="!editMode">{{ offerData?.expertiseName }}</span>
                                <mat-form-field *ngIf="editMode" class="mc-form-field mc-form-field__shift-type--width extended-field">
                                    <mat-select formControlName="expertiseId" (selectionChange)="checkRateUpdateFields('Specialty')" [disabled]="!detailsFormGroup?.controls.candidateProfessionId.value">
                                        <mat-option *ngFor="let option of expertise" [value]="option.id">{{ option.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                        </tr>

                        <tr><td colspan="2"></td></tr>
                        <ng-container>
                            <tr>
                                <td>
                                    <span class="label-text">Contract Length</span>
                                </td>
                                <td *ngIf="editMode">
                                    <div>
                                        <mat-form-field class="contractLength">
                                            <input type="number" matInput (change)="calculateContractDates('weeksLengthChanged')"
                                                formControlName="contractLength">
                                                <mat-error>Please enter valid Weeks Length.</mat-error>
                                        </mat-form-field>
                                        <span class="label-text"> Weeks</span>
                                    </div>
                                    <div>
                                        <mat-form-field class="contractLength">
                                            <input type="number" matInput (change)="calculateContractDates('daysLengthChanged')"
                                                formControlName="contractLengthDays">
                                                <mat-error >Please enter valid Days Length.</mat-error>
                                        </mat-form-field>
                                        <span class="label-text"> Days</span>
                                        <mat-icon *ngIf="contractLengthDaysApprovalRequired" class="info-icon" [matTooltip]="contractLengthDaysInfoMessage">info</mat-icon>
                                    </div>
                                </td>
                                <td *ngIf="!editMode">
                                    <div class="weekDaysDisplay">
                                        <span>{{displayedContractLengthWeeks}} Weeks</span>
                                    </div>
                                    <div>
                                        <span>{{displayedContractLengthDays}} Days</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">
                                    {{editMode && offerData?.offerType === offerTypeEnum.Direct ? 'Start *' : 'Start'}}</span></td>
                                <td>
                                    <span *ngIf="!editMode">{{ offerData?.startDate }}</span>
                                    <mat-form-field *ngIf="editMode">
                                        <input matInput [matDatepicker]="picker" formControlName="startDate"
                                            (dateChange)="calculateContractDates('startDateChanged')">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error>Please enter valid start date.</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">{{editMode && offerData?.offerType === offerTypeEnum.Direct ? 'End *' :
                                        'End'}}</span></td>
                                <td>
                                    <span *ngIf="!editMode">{{ endDateTextWithoutWeeks }}</span>
                                    <mat-form-field *ngIf="editMode">
                                        <input matInput [matDatepicker]="picker" formControlName="endDate" [min]="minEndDate"
                                            (dateChange)="calculateContractDates('endDateChanged')">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error>Please enter valid end date.</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>
                        </ng-container>

                        <tr *ngIf="!editMode">
                            <td><span class="label-text">Shifts</span></td>
                            <td>
                                <span>{{ offerData?.shiftsText }}</span>
                            </td>
                        </tr>

                        <ng-container>
                            <tr *ngIf="editMode">
                                <td>
                                    <span class="label-text">Shift Type <span>*</span></span>
                                </td>
                                <td>
                                    <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                        <mat-select formControlName="shiftTypeId">
                                            <mat-option *ngFor="let option of lookups?.shiftTypes" [value]="option.key">{{ option.value }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftTypeId', 'required')">Shift Type is required</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>

                            <tr *ngIf="editMode">
                                <td>
                                    <span class="label-text"># of Shifts <span>*</span></span>
                                </td>
                                <td [ngClass]="{'twoColTd' : viewAltShift}">
                                    <mat-form-field class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shifts" (selectionChange)="calculateContractDates('numOfShiftsChanged')">
                                            <mat-option *ngFor="let num of shiftValues" [value]="num">{{ num }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shifts', 'required')"># of Shifts is required</mat-error>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="viewAltShift" class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shiftsAlt">
                                            <mat-option *ngFor="let num of shiftValues" [value]="num">{{ num }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftsAlt', 'required')"># of Alt Shifts is required</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>

                            <tr *ngIf="editMode">
                                <td>
                                    <span class="label-text">Shift Length <span>*</span></span>
                                </td>
                                <td [ngClass]="{'twoColTd' : viewAltShift}">
                                    <div class="tdSplit">
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="hours" (selectionChange)="checkRateUpdateFields('Shift Length')">
                                                <mat-option *ngFor="let length of hoursValue" [value]="length">{{ length }}</mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="hasError('hours', 'required')">Shift Length is required</mat-error>
                                        </mat-form-field>
                                        <span class="label-text ml">Hours</span>
                                    </div>
                                    <div class="tdSplit" *ngIf="viewAltShift">
                                        <mat-form-field class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="hoursAlt" (selectionChange)="onShiftLengthAltChanged()">
                                                <mat-option *ngFor="let length of hoursValue" [value]="length">{{ length }}</mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="hasError('hoursAlt', 'required')">Alt Shift Length is required</mat-error>
                                        </mat-form-field>
                                        <span class="label-text ml">Hours</span>
                                    </div>
                                </td>
                            </tr>

                            <tr *ngIf="editMode">
                                <td>
                                    <span class="label-text">Shift Time of Day <span>*</span></span>
                                </td>
                                <td [ngClass]="{'twoColTd' : viewAltShift || isRotatingShift}">
                                    <mat-form-field class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shiftTimeOfDayId" (selectionChange)="checkRateUpdateFields('Shift Type')">
                                            <mat-option *ngFor="let option of lookups?.shiftTimes" [value]="option.key">{{ option.value }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftTimeOfDayId', 'required')">Shift Time of Day is required</mat-error>
                                    </mat-form-field>

                                    <mat-form-field *ngIf="viewAltShift || isRotatingShift" class="mc-form-field mc-form-field__shift-type--width tdSplit">
                                        <mat-select formControlName="shiftAltTimeOfDayId">
                                            <mat-option *ngFor="let option of lookups?.shiftTimes" [value]="option.key">{{ option.value }}</mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="hasError('shiftAltTimeOfDayId', 'required')">Alt Shift Time of Day is required</mat-error>
                                    </mat-form-field>
                                </td>
                            </tr>

                            <tr *ngIf="editMode">
                                <td>
                                    <span class="label-text">Shift Time</span>
                                    <span class="under-label">Optional</span>
                                </td>
                                <td [ngClass]="{'twoColTd' : viewAltShift || isRotatingShift}">
                                    <div class="tdSplit">
                                        <table class="inner-table" aria-label="shift times">
                                            <tr class="hidden">
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text mr">Start</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                                      formControlName="shiftTimeStart"
                                                                      (valueChange)="onTimeStartChanged($event)" format="HH:mm">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text mr">End</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                                      formControlName="shiftTimeEnd"
                                                                      (valueChange)="onTimeEndChanged($event)" format="HH:mm">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="tdSplit" *ngIf="viewAltShift || isRotatingShift">
                                        <table class="inner-table" aria-label="alt shift times">
                                            <tr class="hidden">
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                                <th scope="col"></th>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text mr">Start</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                                      formControlName="shiftAltTimeStart"
                                                                      (valueChange)="onAltTimeStartChanged($event)" format="HH:mm">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><span class="label-text mr">End</span></td>
                                                <td>
                                                    <kendo-timepicker class="kendo-input-field"
                                                                      formControlName="shiftAltTimeEnd"
                                                                      (valueChange)="onAltTimeEndChanged($event)" format="HH:mm">
                                                    </kendo-timepicker>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>

                        <tr *ngIf="!editMode && offerData?.shiftDetails">
                            <td><span class="label-text">Shift Details</span></td>
                            <td>
                                <span>{{ offerData?.shiftDetails }}</span>
                            </td>
                        </tr>

                        <tr *ngIf="editMode">
                            <td><span class="label-text">Shift Details</span></td>
                            <td>
                                <textarea formControlName="shiftDetails" class="other-notes-textarea"></textarea>
                            </td>
                        </tr>

                        <tr><td colspan="2"></td></tr>
                        <tr *ngIf="editMode">
                            <td><span class="label-text">RTO</span></td>
                            <td>
                                <mat-checkbox formControlName="hasRequestedTimeOff"></mat-checkbox>
                            </td>
                        </tr>

                        <tr *ngIf="!editMode && offerData?.hasRequestedTimeOff">
                            <td><span class="label-text">RTO Dates</span>
                                <nova-rto-alert-icon [enabled]="enableRtoAlertMessageForViewEditOfferFlag() && showRTOAlertOnStartEndDates">
                                </nova-rto-alert-icon>
                            </td>
                            <td>

                                <div>
                                    <span>{{ offerData?.requestedTimeOffDateText }}</span>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="!editMode && offerData?.hasRequestedTimeOff">
                            <td><span class="label-text">RTO Approval</span></td>
                            <ng-container>
                                <td>
                                    <span>{{getRtoApprovalStatus()}}</span>
                                </td>
                            </ng-container>
                        </tr>

                        <ng-container *ngIf="editMode && detailsFormGroup.controls.hasRequestedTimeOff.value">
                            <tr>
                                <td><span class="label-text">RTO Dates</span></td>
                                <td>
                                    <div *ngIf="editMode" class="rto-container">
                                        <div class="date-input-container">
                                            <div class="days">
                                                <span>{{ daysRequested }}</span>
                                            </div>
                                            <button class="rto-btn" mat-icon-button [matMenuTriggerFor]="appMenu">
                                                <mat-icon>event</mat-icon>
                                            </button>
                                        </div>

                                        <mat-menu #appMenu="matMenu" class="drop-calendar">
                                            <div (click)="$event.stopPropagation()">
                                                <mat-calendar #calendar class="mat-calendar rto-clanedar" [dateClass]="dateClass()" [maxDate]="maxDate" [minDate]="minDate" (selectedChange)="dateChanged($event)"></mat-calendar>
                                            </div>
                                        </mat-menu>

                                        <a class="nova-link rto-clear__btn" [class.disabled]="daysSelected.length ?  false : true" (click)="clearDates()" #clearCalendarTrigger="matMenuTrigger" [matMenuTriggerFor]="appMenu">Clear</a>
                                    </div>
                                    <div class="offer-rto-warning">
                                        <nova-rto-warning-message [enabled]="enableRtoAlertMessageForViewEditOfferFlag() && showRTOAlertOnStartEndDates">                                      
                                        </nova-rto-warning-message> 
                                    </div>                                  
                                </td>
                            </tr>
                            <tr>
                                <td><span class="label-text">RTO Approval</span></td>
                                <ng-container>
                                    <td>
                                        <mat-form-field *ngIf="editMode" class="mc-form-field mc-form-field__shift-type--width">
                                            <mat-select formControlName="rtoApprovalStatus" data-qa-id="RTOApprovalStatusEdit">
                                                <mat-option [value]="1">Approved</mat-option>
                                                <mat-option [value]="2">Pending Approval</mat-option>
                                                <mat-option [value]="3">Not Approved</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                        <tr><td colspan="2"></td></tr>
                        <tr>
                            <td><span class="label-text">Facility Rate</span></td>
                            <td>
                                <span *ngIf="!editMode">{{ offerData?.facilityRate | currency }}</span>
                                <span *ngIf="editMode" class="label-text mr">$</span>
                                <mat-form-field *ngIf="editMode">
                                    <input type="number" matInput formControlName="facilityRate" (keydown)="validateInput($event)"
                                        (keyup)="updateVendorRate()" (change)="calculateContractDates('facilityRateChanged')">
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr *ngIf="offerData?.recruiterBonus">
                            <td><span class="label-text">Doughboy</span></td>
                            <td><span><nova-recruiter-bonus [bonus]="offerData?.recruiterBonus"></nova-recruiter-bonus></span></td>
                        </tr>
                        <tr *ngIf="(isAyaPaidBonusEnabled$ | async) === true && offerData?.offerType === offerTypeEnum.Direct">
                            <td><span class="label-text">Aya Paid Bonus</span></td>
                            <td>                                
                                <span *ngIf="!editMode" data-qa-id="ayaPaidBonus">{{ (offerData?.ayaPaidBonus ?? 0) | currency }}</span>
                                <span *ngIf="editMode" class="label-text mr">$</span>
                                <mat-form-field *ngIf="editMode">
                                    <input type="number" matInput formControlName="ayaPaidBonus" (keydown)="validateInput($event)" 
                                        data-qa-id="ayaPaidBonusInput" min="0"  max="999999.99">
                                    <mat-error >Please enter valid bonus amount.</mat-error>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr *ngIf="offerData?.offerType !== offerTypeEnum.Direct">
                            <td><span class="label-text">Vendor Rate</span></td>
                            <td class="vendor-row">
                                <span *ngIf="!editMode">{{ offerData?.vendorRate | currency }}</span>
                                <span *ngIf="editMode && rateEnabled" class="label-text mr">$</span>
                                <span *ngIf="editMode && !rateEnabled">{{ detailsFormGroup?.controls['vendorRate']?.value | currency }}</span>
                                <span *ngIf="editMode && !rateEnabled" (click)="rateEdit()" class="material-icons pencil">edit</span>
                                <mat-form-field *ngIf="editMode && rateEnabled">
                                    <input type="number" matInput formControlName="vendorRate" (keydown)="validateInput($event)">
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr *ngIf="offerData?.otherDetails || editMode"><td colspan="2"></td></tr>
                        <tr *ngIf="offerData?.otherDetails || editMode">
                            <td><span class="label-text">Other Details</span></td>
                            <td>
                                <ng-container *ngIf="editMode; else otherDetailsNonEdit">
                                    <textarea formControlName="otherDetails" class="other-notes-textarea" data-qa-id="OtherDetails"></textarea>
                                </ng-container>
                                <ng-template #otherDetailsNonEdit>
                                    <span [innerHTML]="offerData?.otherDetails"></span>
                                </ng-template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </mat-card>
        <div class="attachments-notes-container">
            <mat-card class="attachments">
                <nova-shared-offer-attachments
                    [editMode]="editMode"
                    [canModify]="canModify"
                    [attachments]="attachmentData"
                    [offerType]="offerData?.offerType"
                    [headingTitle]="attachmentsHeadingTitle"
                    [headingTitleSubtext]="attachmentsHeadingTitleSubtext"
                    (attachmentUpload)="attachmentToUpload($event)"
                    (attachmentUpdate)="attachmentToUpdate($event)"
                    (attachmentDelete)="attachmentToDelete($event)"
                    (getAttachmentFile)="attachmentToGet($event)"></nova-shared-offer-attachments>
            </mat-card>

            <mat-card class="notes">
                <nova-shared-notes
                    [agencyNotes]="offerNotes"
                    [offerType]="offerData?.offerType"
                    [userType]="userType"
                    [headingTitle]="notesHeadingTitle"
                    [headingTitleSubtext]="notesHeadingTitleSubtext">
                    <div *ngIf="canModify" noteInput class="note-input">
                        <textarea class="note-textarea" data-qa-id="an_shared_notes_textarea" [(ngModel)]="enteredNoteText"></textarea>
                        <ng-container *ngIf="!shouldDisplayNoteCategoryButtons">
                            <button class="mat-raised-button mat-primary"
                                color="primary"
                                [disabled]="!enteredNoteText"
                                (click)="addNote()"
                                data-qa-id="an_shared_notes_send_note">
                                Send Note
                            </button>
                        </ng-container>
                        <ng-container *ngIf="shouldDisplayNoteCategoryButtons">
                            <button class="mat-raised-button mat-primary"
                                color="primary"
                                [disabled]="!enteredNoteText"
                                (click)="addNoteWithCategory(offerNotesCategory.ClientFacing)"
                                data-qa-id="an_shared_notes_send_to_client">
                                Send Note to Client
                            </button>
                            <button class="mat-raised-button mat-secondary right-button-margin"
                                color="primary"
                                [disabled]="!enteredNoteText"
                                (click)="addNoteWithCategory(offerNotesCategory.NonClientFacing)"
                                data-qa-id="an_shared_notes_send_to_recruiter">
                                Send Note to Recruiter
                            </button>
                        </ng-container>
                    </div>
                </nova-shared-notes>
            </mat-card>
        </div>
    </div>
</div>
